/**
 * Safe access to environment variables
 * Works in both Node.js and browser environments
 * @param {string} key - Environment variable key
 * @returns {string|undefined} Environment variable value or undefined
 */
export const getEnvVar = key => {
  try {
    return typeof process !== 'undefined' && process.env
      ? process.env[key]
      : undefined
  } catch (e) {
    return undefined
  }
}

/**
 * Check if we're in development mode
 * @returns {boolean} True if in development mode
 */
export const isDevelopment = (() => {
  try {
    return typeof process !== 'undefined' && process.env
      ? !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
      : true // Default to development if process is not available
  } catch (e) {
    return true // Default to development if there's an error
  }
})()
